import React from "react";
import { Box, Button, Icon, InlineStack } from "@shopify/polaris";
import { ChevronRightMinor } from "@shopify/polaris-icons";
import _ from "lodash";
import intl from "../../../../../i18n/intl";
import {
  PlayCircleMajor,
} from '@shopify/polaris-icons';
import { connect, useSelector} from "react-redux";
import LevelAction from "../../../../../components/LevelAction";
const Top3Btn = ({ onChange,callChange,setNoviceModal }) => {
  const language = useSelector(state => state.languageReducer.language);
  const shopify_level = useSelector(state => state.languageReducer.subScriptData.shopify_level);
  const level = useSelector(state => state.languageReducer.subScriptData.level);
  const shopifyLevel = ()=>{
    let flag = true;
    if (level === 0 && (shopify_level === 'Development' || shopify_level === 'Developer Preview' || shopify_level === 'staff' || shopify_level === 'staff_business')) {
      flag = false
    }
    return flag;
  }
  const top3Btn = [
    {
      prefix: <img src={"/crown.png"} alt={"crown"} />,
      img: <img src={"/ali_express.png"} alt={"ali_express"} height={20} />,
      text: (
        <span className="itemText" title={intl.get("Import products from AliExpress")}>
          {intl.get("Import products from AliExpress")}
        </span>
      ),
      type: "AliExpress",
    },
    {
      // prefix: <img src={"/crown.png"} alt={"crown"}/>,
      img: <img src={"/temu/temu_icon.png"} alt={"temu"} height={25} />,
      text: (
        <span className="itemText" title={intl.get("Import products from TEMU")}>
          {intl.get("Import products from TEMU")}
        </span>
      ),
      type: "temu",
    },
    {
      img: <img src={"/Vstar_logo.png"} alt={"Vstar_logo"} height={25} />,
      text: (
        <span className="itemText" title={intl.get("1-click import Ali product reviews")}>
          {intl.get("1-click import Ali product reviews")}
        </span>
      ),
    },
  ];

  const handleClick = (val) => {
    if (val === 'AliExpress') {
      onChange(val, true);
    }else {
      callChange();
    }
  };
  const topButtonGroup = (val) => {
    const Item = _.map(top3Btn, (item, index) => {
      return (
        <div className="group_level" key={index}>
        <Button
          url={
            val?.[index]?.type
              ? ""
              : "https://share.channelwill.com/app/2164b757c48accfqZu"
          }
          external={val?.[index]?.type ? false : true}
          onClick={
            val?.[index]?.type
              ? () => handleClick(val?.[index]?.type)
              : () => {}
          }
        >
          <div className="btnContent">
            <div className="leftContent">
              <div className="leftContent_img">
              {val?.[index]?.prefix ? val?.[index]?.prefix : null}
              {val?.[index]?.text}
              </div>
              <div className="prefixIcon">
                {val?.[index]?.img}
              </div>
            </div>
            <Icon source={ChevronRightMinor} color="base" />
          </div>
        </Button>
        {!shopifyLevel() && val?.[index]?.type === 'AliExpress' && <LevelAction callBack={()=>handleClick(val?.[index]?.type)} img={'16px'} borderRadius={'5px'} font={'12px'}/> }
        </div>
      );
    });
    return <div className="topButtonGroup">
      {Item}
      <Box className={`list_product_head_video list_product_head_video-${language}`}>
            <Button onClick={()=>setNoviceModal(true)}>
              <InlineStack blockAlign='center'>
              <Icon
              source={PlayCircleMajor}
              tone="base"
            /> {intl.get("Watch Tutorial")}
            </InlineStack>
            </Button>
            </Box>
      </div>;
  };

  return topButtonGroup(top3Btn);
};

export default connect()(Top3Btn);
